import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';
import { IAgendamentoTarefa, ITarefa } from '../types/tarefa';
import { v4 as uuidv4 } from 'uuid';
import { formatarHoraCurta } from '../common/utils/formatadorDataHora';

interface IPropsTarefasContext {
    tarefas: ITarefa[],
    setTarefas: Dispatch<SetStateAction<ITarefa[]>>,
}

interface IPropsTarefaContext {
    tarefa: ITarefa,
    setTarefa: Dispatch<SetStateAction<ITarefa>>,
}

interface IProps {
    children: JSX.Element[] | JSX.Element
}

const TarefasContext = createContext<IPropsTarefasContext>({} as IPropsTarefasContext);
const TarefaContext = createContext<IPropsTarefaContext>({} as IPropsTarefaContext);

const TarefasProvider = ({ children }: IProps) => {
    const [tarefas, setTarefas] = useState<ITarefa[]>([]);
    return (<TarefasContext.Provider value={{
        tarefas,
        setTarefas
    }}>
        {children}
    </TarefasContext.Provider>)
};

export const TarefaProvider = ({ children }: IProps) => {
    const [tarefa, setTarefa] = useState<ITarefa>(novaTarefa());

    return (<TarefaContext.Provider value={{
        tarefa,
        setTarefa
    }}>
        {children}
    </TarefaContext.Provider>)
};

export function useTarefas(): [ITarefa[], Dispatch<SetStateAction<ITarefa[]>>] {
    const context = useContext(TarefasContext);
    const { tarefas, setTarefas } = context;
    return [tarefas, setTarefas];
}

export function useTarefa(): [ITarefa, Dispatch<SetStateAction<ITarefa>>] {
    const context = useContext(TarefaContext);
    const { tarefa, setTarefa } = context;
    return [tarefa, setTarefa];
}

export function novaTarefa(): ITarefa {
    const agendamentoDiario: IAgendamentoTarefa = {
        id: uuidv4(),
        tipo: "Diariamente",
        horaExecucao: formatarHoraCurta(new Date())
    }

    return {
        id: uuidv4(),
        clienteID: "",
        nome: "",
        tipo: "",
        plataforma: "windows",
        agendamento: agendamentoDiario,
        dataInicio: new Date(),
        dataFim: new Date("2200-12-31"),
        ultimaExecucao: undefined,
        posExecucao: []
    }
}

export default TarefasProvider;
 